import { ReactElement, useState } from 'react';

import { InformationIcon } from '@amazd/common/icons/InformationIcon';
import { Box, BoxProps, IconButton, Popover, Typography } from '@mui/material';

import useStyles from './styles';

interface Props extends BoxProps {
  img: ReactElement;
  title: string;
  subtitle: string;
}

const InformationHint = ({ img, title, subtitle, ...boxProps }: Props) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <Box {...boxProps}>
      <IconButton className={classes.trigger} onMouseEnter={handleOpen} onMouseLeave={handleClose}>
        <InformationIcon />
      </IconButton>
      <Popover
        onClick={handleClose}
        style={{ pointerEvents: 'none' }}
        PaperProps={{
          style: { borderRadius: 20, boxShadow: 'none' },
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <Box className={classes.container} display="flex">
          <Box className={classes.image}>{img}</Box>
          <Box className={classes.text}>
            <Typography className={classes.title}>{title}</Typography>
            <Typography className={classes.subitle}>{subtitle}</Typography>
          </Box>
        </Box>
      </Popover>
    </Box>
  );
};

export default InformationHint;
